import { DateUtils }     from '@utils/helpers';
import { DatePartsEnum } from '@utils/helpers/date-utils';

export const isUsageYearMonthValid = ( usageYearMonth: string ) => /^(19[7-9][0-9]|[2-9][0-9]{3})([0][1-9]|[1][0-2])$/.test( usageYearMonth );
export const isUsageYearValid = ( usageYear: string ) => /^(19[7-9][0-9]|[2-9][0-9]{3})$/.test( usageYear );

const getUsagePeriod = (
	date: Date,
	formatOptions: Intl.DateTimeFormatOptions,
	datePartsOrder: DatePartsEnum[]
): string => {
	return DateUtils.getStringFormattedDate( date, formatOptions, datePartsOrder );
};


export const getYear = ( date?: Date ): string => {
	return getUsagePeriod(
		date ?? new Date(),
		{ year: 'numeric' },
		[ DatePartsEnum.YEAR ]
	);
};

export const getYearMonth = ( date?: Date ): string => {
	return getUsagePeriod(
		date ?? new Date(),
		{ year: 'numeric', month: '2-digit' },
		[ DatePartsEnum.YEAR, DatePartsEnum.MONTH ]
	);
};

export const getYearMonthDay = ( date?: Date ): string => {
	return getUsagePeriod(
		date ?? new Date(),
		{ year: 'numeric', month: '2-digit', day: '2-digit' },
		[ DatePartsEnum.YEAR, DatePartsEnum.MONTH, DatePartsEnum.DAY ]
	);
};
